module.exports = __webpack_public_path__ + "img/paris-hilton-2025.5061ed22.webp";